import React from 'react';
import HavenNav from '../HavenNav/HavenNav';

import './Faq.css'

const HavenFaq = (props) => {

    return (
        <div>
            <HavenNav />
         
           
        </div>
    )
}

export default HavenFaq;


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/Faq/Faq.jsx